module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Predator-The.e9648a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Predator-The.jpg
// module id = BkBx
// module chunks = 0